import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.jsx';
import { usePremium } from '../context/PremiumContext.jsx';
import api from '../api.js';
import LoadingState from '../components/LoadingState.jsx';

export default function PastGames() {
  const { user } = useAuth();
  const { premium } = usePremium();
  const navigate = useNavigate();
  const [games, setGames] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user?.uid) {
      setLoading(false);
      return;
    }
    setLoading(true);
    api
      .getGameHistory(user.uid)
      .then((r) => setGames(r?.games || r || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [user?.uid]);

  const visible = premium ? games : games.slice(0, 3);

  return (
    <div className="screen">
      <div className="screen-header">
        <button className="back-btn" onClick={() => navigate(-1)}>←</button>
        <h1>Past Games</h1>
        <div className="spacer" />
      </div>

      <LoadingState
        loading={loading}
        empty={visible.length === 0}
        emptyIcon="⛳"
        emptyTitle="No games yet"
        emptyHint="Your finished rounds will show up here."
      >
        <div className="stack-sm">
          {visible.map((g, i) => (
            <button
              key={g.code || i}
              className="feed-card"
              onClick={() => navigate(`/game/${g.code}/results`)}
            >
              <div className="feed-card-icon">🏆</div>
              <div className="grow">
                <h4>{g.city || 'Game'} · {g.holes || 9} holes</h4>
                <div className="sub">
                  {g.winner || 'No winner'} · {g.total || '—'} strokes
                </div>
              </div>
              <div style={{ color: 'var(--text20)' }}>›</div>
            </button>
          ))}
        </div>
      </LoadingState>

      {!premium && games.length > 3 && (
        <div className="card" style={{ marginTop: '1rem', textAlign: 'center' }}>
          <div className="text-muted" style={{ marginBottom: '0.75rem' }}>
            Unlock full history with Premium
          </div>
          <button
            className="btn btn-primary"
            onClick={() => navigate('/premium')}
          >
            Upgrade
          </button>
        </div>
      )}
    </div>
  );
}
